export default "__VITE_ASSET__CoU9RBc6__"